import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = window.setTimeout(() => this.dismiss(), 6000)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }

  dismiss() {
    if (this.element.dataset.dismissing === "true") return

    this.element.dataset.dismissing = "true"
    this.element.classList.add("flash-toast--dismissing")

    window.setTimeout(() => this.element.remove(), 180)
  }
}
